import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { UnsavedChangesService } from '@app/services/unsaved-changes.service';

@Component({
  selector: 'app-designer-layout',
  templateUrl: './designer-layout.component.html',
  styleUrl: './designer-layout.component.scss'
})
export class DesignerLayoutComponent {
  constructor(
    private router: Router,
    private location: Location,
    private auth: AuthService,
    private unsaved: UnsavedChangesService
  ) {}

  isActive(path: string): boolean {
    const u = this.router.url.split('?')[0];
    return u === path || u.startsWith(path + '/');
  }

  navigateTo(path: string, event: Event): void {
    event.preventDefault();
    this.unsaved.runIfSafe(() => this.router.navigateByUrl(path));
  }

  goBack(): void {
    this.unsaved.runIfSafe(() => {
      if (window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigateByUrl('/designer/template-list');
      }
    });
  }

  requestLogout(): void {
    this.unsaved.runIfSafe(() => {
      this.auth.logout();
      this.router.navigate(['/login']);
    });
  }
}
